import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "./Portfolio.css";

function PortfolioDetail() {
  const { id } = useParams(); 
  const [item, setItem] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchItem = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/public/portfolio/${id}`,
          { withCredentials: true }
        );
        setItem(response.data);
      } catch (error) {
        console.error("Error fetching portfolio detail:", error.message);
      }
    };

    fetchItem();
  }, [id]);

  if (!item) return <p>Loading...</p>;

  return (
    <div className="portfolio-detail">
      {/* <button className="back-btn" onClick={() => navigate(-1)}>← Back</button> */}
      <div className="title-image-container">
      <h2>{item.title}</h2>
      <div className="portfolio-image-round">
      <img src={item.image1} alt="preview 1" />
      </div>
      </div>
      <div className="portfolio-detail-content">

        <div className="portfolio-video">
          <video controls>
            <source src={item.video} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      
        <div className="portfolio-images">
          <img src={item.image1} alt="preview 1" />
          <img src={item.image2} alt="preview 2" />
        </div>
      </div>
      <div className="portfolio-description">{item.description}</div>
    </div>
  );
}

export default PortfolioDetail;
